<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Přehled faktur</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4 md3>
                <osobasearch label="Klient" v-model="osoba" class="mx-2" all></osobasearch>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{props.item.id}}</td>
                  <td>{{props.item.cas | formatDate}}</td>
                  <td>{{props.item.variabilni_symbol}}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    <span v-if="props.item.typ=='sporeni'">Spoření</span>
                    <span v-else-if="props.item.typ=='jednorazovy_nakup'">Jednorázový nákup</span>
                  </td>
                  <td>{{props.item.fixovana_castka | formatMoney}} {{props.item.mena.zkratka}}</td>
                  <td>
                    <span v-if="props.item.stav=='vystavit'">K vystavení</span>
                    <span v-else-if="props.item.stav=='par_90_ceka'">§ 90, čeká na sklad</span>
                    <span v-else-if="props.item.stav=='vystaveno'">Vystaveno</span>
                  </td>
                  <td>{{props.item.flexibee_id}}</td>
                  <td>{{props.item.interni_cislo}}</td>
                  <td class="text-xs-center">
                    <a :href="api_url + 'faktury/' + props.item.id + '/pdf'" target="_blank">
                      <v-btn color="primary" v-if="props.item.pdf" depressed><v-icon>cloud_download</v-icon></v-btn>
                    </a>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Datum', value: 'cas' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Osoba', value: 'osoba' },
        { text: 'Typ', value: 'typ' },
        { text: 'Fixovaná částka', value: 'fixovana_castka' },
        { text: 'Stav', value: 'stav' },
        { text: 'Flexibee ID', value: 'flexibee_id' },
        { text: 'Interní číslo', value: 'interni_cislo' },
        { text: 'Stáhnout', value: 'id', sortable: false, align: 'center' }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
      osoba: null,
      totalItems: 0
    }
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
    osoba () {
      this.load();
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/faktury/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        osoba: this.osoba
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/PrehledFaktury.vue